import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: 600,
    padding: '10px',
    cursor: 'move',
  },
}));
